const TIMEOUT = 500;

export const debounce = (func: any, timeout = TIMEOUT) => {
  let inDebounce: any;
  return (...args: any[]) => {
    clearTimeout(inDebounce);
    inDebounce = setTimeout(() => func(...args), timeout);
  };
};

export const convertToNumber = (value: any) => {
  if (typeof value === "number" && !Number.isNaN(value)) {
    return value;
  }

  if (typeof value === "string") {
    const trimmedValue = value.trim();
    if (trimmedValue) {
      return Number(trimmedValue);
    }
  }

  return NaN;
};

export const maskCharacters = (
  stringToMask: string,
  noOfCharsToRemainUnmasked: number = 4,
  character: string = "*"
) => {
  if (!stringToMask) return "";

  const regex = new RegExp(`.(?=.{${noOfCharsToRemainUnmasked}})`, "g");
  return stringToMask.replace(regex, character);
};
